import { useMutation, useQuery } from "@apollo/client";
import { Box, CircularProgress, Stack } from "@mui/material";
import { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FETCH_AVATARS } from "../../../../../graphql/query/query";
import Theme from "../../../../../utils/Theme";
import { DEALERSHIP_AVATAR } from "../../../../../graphql/mutation/mutation";
import { useNavigate, useParams } from "react-router-dom";

const AvatarsComponent = ({ edit, selectedAvatar, setSelectedAvatar }) => {
  const { dealershipId } = useParams();
  const navigate = useNavigate();

  const { data: avatarsArray, loading } = useQuery(FETCH_AVATARS);
  const [dealershipAvatar] = useMutation(DEALERSHIP_AVATAR);

  const handleSelect = (avatarId, gender, id) => {
    setSelectedAvatar(avatarId);

    dealershipAvatar({
      variables: {
        avatarInput: {
          avatar_id: avatarId,
          gender: gender,
          dealership_id: parseInt(dealershipId),
          id: id,
        },
      },
    });
  };

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "50vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ p: 2, width: "100%", height: "100%", pt: 8 }}
        >
          {avatarsArray?.fetchAvatars?.avatars?.map((avatar) => (
            <Box
              key={avatar.avatar_id}
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                borderRadius: "8px",
                overflow: "hidden",
                padding: "8px",
                backgroundColor: "#fff",
                boxShadow:
                  selectedAvatar === avatar.avatar_id
                    ? "0 0 12px #00ab55"
                    : "none",
                "&:hover": {
                  boxShadow: "0 0 12px rgba(0, 0, 0, 0.3)",
                  border: "2px solid #00ab55",
                },
              }}
              onClick={() =>
                handleSelect(avatar.avatar_id, avatar.gender, avatar.id)
              }
            >
              {selectedAvatar === avatar.avatar_id && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    borderRadius: "50%",
                  }}
                >
                  <CheckCircleIcon
                    sx={{
                      color: Theme.palette.primary.main,
                      fontSize: 30,
                    }}
                  />
                </Box>
              )}
              <img
                src={avatar.avatar_url}
                alt={`Avatar ${avatar.avatar_id}`}
                style={{
                  width: !edit ? "150px" : "200px",
                  height: "300px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  "&:hover": {
                    boxShadow: "0 0 12px #00ab55",
                  },
                }}
              />
            </Box>
          ))}
        </Stack>
      )}
    </>
  );
};

export default AvatarsComponent;
